import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Policy Logistics · Your Trusted Partner</p>
        <h1>Streamline Your Logistics Today</h1>
        <p className="lede">
          At Policy Logistics, we simplify your logistics needs with innovative solutions tailored for you. 
          Experience seamless operations and enhanced efficiency with our expert services.
        </p>
        <div className="cta-row">
          <a href="/services" target="_blank">
            Explore Our Services
          </a>
          <a href="/contact" target="_blank" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Efficient Solutions</h2>
          <p>
            Our logistics solutions are designed to optimize your supply chain, ensuring timely deliveries and reduced costs.
          </p>
        </article>
        <article>
          <h2>Expert Support</h2>
          <p>
            Our dedicated team is here to assist you at every step, providing personalized support and guidance tailored to your business.
          </p>
        </article>
        <article>
          <h2>Innovative Technology</h2>
          <p>
            Leverage our cutting-edge technology to gain real-time insights and streamline your logistics operations effortlessly.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;